<template>
  <d2-container class="page" v-loading="loading" element-loading-text="加载中...">
    <!-- 返回按钮 -->
    <div class="float_button">
      <div class="float_info" @click="$router.back()"
        style="top: 150px;background: rgba(255, 255, 255, 0.5);width: 40px;height: 40px;font-size:12px;border-radius: 1px;right: 2%;">
        <d2-icon name='mail-reply-all' />
        返回
      </div>
    </div>
    <!--  -->
    <el-row class="h100" v-if="query.code == 'activity'">
      <!-- 详情 -->
      <el-col :span="24" class="scrollable full_scroll">
        <div class="web_intro">
          <img :src="webData.FaceImage" width="430" height="235" />
          <div class="web_intro_detial">
            <h2>{{ webData.ActivityName }}</h2>
            <div class="line"></div>
            <div class="s1">
              <p>
                {{
                  webData.ActivityParton == "专项礼品"
                    ? "领取日期："
                    : "活动日期："
                }}{{ webData.StartTime }} ~ {{ webData.EndTime }}
              </p>
              <p v-if="webData.ActivityParton != '专项礼品'">
                <template v-if="webData.ActivityParton != '其他'">报名日期：{{ webData.SignUpStartTime }} ~
                  {{ webData.SignUpEndTime }}</template>
              </p>
              <p>活动类型：{{ webData.ActiveTypeHidden }}</p>
              <p v-if="webData.ActivityParton == '专项礼品'">
                预约状态：{{ isApply ? "已预约" : "未预约" }}
              </p>
              <p>发布人：{{ webData.ActivityManager }}</p>
              <p v-if="
                  webData.ActivityParton == '专项礼品' &&
                  webData.ConsultationPhone
                ">
                咨询电话：{{ webData.ConsultationPhone }}
              </p>
              <el-row v-if="webData.ActivityParton != '其他'">
                <el-col :span="12">
                  <p>
                    报名状态：<el-tag :type="!isApply ? 'info' : isHouBu ? 'warning' : ''" size="small" effect="dark">{{
                        !isApply ? "未报名" : isHouBu ? "候补中" : "已报名"
                      }}</el-tag>
                  </p>
                </el-col>
                <el-col :span="12">
                  <p>
                    活动状态：<el-tag size="small" effect="dark">{{
                      webData.CurrentStatus
                    }}</el-tag>
                  </p>
                </el-col>
              </el-row>
              <el-row v-if="webData.ActivityParton != '专项礼品' && webData.ActivityParton != '其他'">
                <el-col :span="8">
                  <p>已报名人数：{{ webData.SignUpPersonCount }}</p>
                </el-col>
                <el-col :span="8" v-if="
                    webData.ActivityParton != '专项礼品' &&
                    webData.ActivityParton != '开工饭/年夜饭' &&
                    webData.ActivityParton != '票务活动' &&
                    webData.HouBuPersonCount
                  ">
                  <p>排队人数：{{ webData.HouBuPersonCount }}</p>
                </el-col>
                <el-col :span="8">
                  <p>已报名人次：{{ webData.SignUpCount }}</p>
                </el-col>
              </el-row>
              <el-row v-if="webData.ActivityParton != '专项礼品'">
                <el-col :span="24" class="s2">
                  <p>
                    <d2-icon name="eye" class="icon" />
                    {{ webData.ReadCount }}
                  </p>
                  <p class="d2-ml-20">
                    <!-- <d2-icon name="thumbs-up" class="icon" /> -->
                    <d2-icon :name="agreeType == 0 ? 'heart-o' : 'heart'" class="icon" />
                    {{ count }}
                  </p>
                </el-col>
              </el-row>
              <el-row v-if="HouBuArray != ''">
                <p>
                  候补排名：<span v-for="(houbu, houbuIndex) in HouBuArray" :key="houbuIndex">
                    {{ houbu.LineName ? houbu.LineName + "：" : "" }}
                    {{ houbu.Position }} 名</span>
                </p>
              </el-row>
            </div>
          </div>
        </div>
        <div>
          <div class="line"></div>
          <div v-html="webData.Intraduction"></div>

          <div class="web_btn" v-if="
              webData.ActivityParton == '通用活动-启用代金券' ||
              webData.ActivityParton == '通用活动-禁用代金券' ||
              webData.ActivityParton == '兴趣俱乐部活动' ||
              webData.ActivityParton == '旅游出行' ||
              webData.ActivityParton == '票务活动' ||
              webData.ActivityParton == '联谊活动'
            ">
            <el-button v-if="isApply" :disabled="endApply || onlyLook" class="add_btn" type="primary" round
              @click="quitApply">取消报名</el-button>
            <el-button v-if="isApply" :disabled="endApply || onlyLook" class="add_btn" type="primary" round
              @click="startSignUp">修改报名</el-button>
            <el-button v-if="isApply" :disabled="endApply || onlyLook" class="add_btn" type="primary" round
              @click="addRemarkHandle">填写备注</el-button>
            <el-button v-else :disabled="endApply || onlyLook" class="add_btn" type="primary" round
              @click="startSignUp">开始报名</el-button>
          </div>
          <div class="web_btn" v-else-if="
              webData.ActivityParton == '健身课程' ||
              webData.ActivityParton == '开工饭/年夜饭' ||
              webData.ActivityParton == '团建活动' ||
              webData.ActivityParton == '会议培训'
            ">
            <el-button v-if="isApply" :disabled="endApply || onlyLook" class="add_btn" type="primary" round
              @click="quitApply">取消报名</el-button>
            <template v-else>
              <el-button v-if="webData.ActivityParton == '健身课程'" :disabled="endApply || onlyLook" class="add_btn"
                type="primary" round @click="startSignUp">我要报名</el-button>
              <el-button v-else :disabled="endApply || onlyLook" class="add_btn" type="primary" round
                @click="enrollHandle">我要报名</el-button>
            </template>
          </div>

          <div class="web_btn" v-else-if="
              webData.ActivityParton == '课程照片' ||
              webData.ActivityParton == '活动评价'
            ">
            <el-button :disabled="endApply || onlyLook" class="add_btn" type="primary" round @click="enrollHandle">提交评价
            </el-button>
          </div>
          <div class="web_btn" v-else-if="webData.ActivityParton == '专项礼品'">
            <el-button v-if="isApply == true" class="add_btn" type="primary" round @click="startSignUp"
              :disabled="endApply || onlyLook">查看详情</el-button>
            <el-button v-else class="add_btn" type="primary" round @click="startSignUp"
              :disabled="endApply || onlyLook">开始预定</el-button>
          </div>
          <div class="web_btn" v-else>
            <el-button v-if="webData.ActivityParton != '其他'" :disabled="endApply || onlyLook" class="add_btn"
              type="primary" round @click="startSignUp">查看详情</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="h100" v-if="query.code == 'comment'">
      <!-- 主席信箱 -->
      <template v-if="query.shortTitle=='主席信箱'">
        <el-card :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <span>{{webData.Title}}</span>
          </div>
          <div style="padding: 14px">
            <span>{{ webData.Content || "-" }}</span>
            <div class="card_question_bottom clearfix">
              <time class="time">发布时间：{{ webData.CreateTime || "-" }}</time>
              <el-button type="text" class="button" icon="el-icon-view">{{
            webData.ReadCount
          }}</el-button>
            </div>
          </div>
          <div style="padding: 0 14px 14px 14px; margin-top: -10px">
            <el-divider content-position="left">主席回复</el-divider>
            <span>{{ webData.Reply || "-" }}</span>
            <div class="card_question_bottom clearfix">
              <time class="time">回复时间：{{ webData.ReplyTime || "-" }}</time>
            </div>
          </div>
        </el-card>
      </template>
      <!-- 工会信息 -->
      <template v-else>
        <!-- 详情 avatarUrl -->
        <el-col :span="18" class="scrollable full_scroll" style="padding-right: 20px">
          <div class="web_intro">
            <img v-if="webData.CoverImg || webData.FmImgUrl"
              :src=" webData.CoverImg ||webData.FmImgUrl ||require('@/assets/img/img404.jpg')" width="430"
              height="235" />
            <div class="web_intro_detial">
              <h2>
                <!-- {{ webData.StationName ? "[ " + webData.StationName + " ]" : "" }} -->
                {{ webData.Title || webData._SUBJECT }}
              </h2>
              <div class="line"></div>
              <div class="s1">
                <div style="display:flex">
                  <img v-if="webData.avatarUrl"
                    :src="webData.avatarUrl.indexOf('http')!=-1?webData.avatarUrl:$apiUrl + webData.avatarUrl"
                    width="85px" height="85px" />
                  <img v-else src="@/assets/img/avatarUrl.png" width="80px" height="80px" />
                  <div style="flex:1;margin-left:10px">
                    <el-row>
                      <el-col :span="12">
                        <p v-if="query.shortTitle!='职代会热点'">发布日期：{{ webData.ReleaseTime }}</p>
                      </el-col>
                      <!-- <el-col :span="12">
                      <p v-if="query.shortTitle!='职代会热点'">信息类型：{{ webData.Type || query.shortTitle }}</p>
                    </el-col> -->
                      <el-col :span="12">
                        <p v-if="webData.CreateUserName">
                          发布人：
                          {{ webData.CreateUserName }}
                        </p>
                        <p v-if="webData.MemberName">
                          发布人：
                          {{ webData.MemberName }}
                        </p>
                      </el-col>
                      <el-col :span="12">
                        <p v-if="webData.MemberName">
                          办事处/城市：
                          {{ webData.WorkUnit }} / {{ webData.City }}
                        </p>
                      </el-col>
                      <el-col :span="12">
                        <p v-if="webData.MemberName">
                          分站/小组：
                          {{ webData.StationName }} / {{ webData.Depart }}
                        </p>
                      </el-col>
                      <el-col :span="12">
                        <p v-if="webData.MemberName">
                          发布时间：
                          {{ webData.CreateTime }}
                        </p>
                      </el-col>
                    </el-row>



                    <el-row>
                      <el-col :span="24" class="s2">
                        <p>
                          <d2-icon name="eye" class="icon" />
                          {{ webData.ReadCount }}
                        </p>
                        <p class="d2-ml-20" v-if="webData.AgreeCount">
                          <d2-icon name="thumbs-up" class="icon" />
                          {{ webData.AgreeCount }}
                        </p>
                        <p class="d2-ml-20" v-else>
                          <span @click="agreeHandle('')">
                            <d2-icon :name="agreeType == 0 ? 'heart-o' : 'heart'" />
                            {{ count }}</span>
                        </p>
                      </el-col>
                    </el-row>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <div>
            <div class="line"></div>
            <template v-if="info.shortTitle == '职代会热点'">
              <div class="web_view_con d2-mt-15 zdh_conbox" v-html="webData.Content"></div>
              <div v-if="webData.Materials" class="auto d2-text-center">
                <template v-for="n in ImgUrlList">
                  <img :key="n" :src="n" style="width:100%" />
                </template>
              </div>
              <div class="web_btn" v-if="isWdfbOption">
                <el-button class="d2-mr-20" type="danger" round icon="el-icon-delete" @click="deleteHandle(webData.ID)">
                  删
                  除</el-button>
                <el-button class="d2-ml-20" type="primary" round icon="el-icon-edit" @click="editHandle(webData)">修 改
                </el-button>
              </div>
            </template>
            <template v-else>
              <div class="web_view_con" v-html="webData.Content || webData.Subject"></div>
              <template v-for="n in ImgUrlList">
                <img :key="n" :src="n" style="width: 100%" />
              </template>
            </template>
          </div>
        </el-col>
        <!-- 评论 -->
        <el-col :span="6" class="scrollable full_scroll web_evaluate" :style="{ height: viewHeight + 'px' }"
          v-loading="loadsing" element-loading-text="提交中...">
          <h2>
            热门评论 <span class="evaluate_title">{{ commentList.length }}</span>
          </h2>
          <div class="evaluate_con" v-if="commentList.length != 0">
            <div class="evaluate_sec" v-for="(item, index) in commentList" :key="index">
              <img v-if="item.avatarUrl" :src="$apiUrl + item.avatarUrl" />
              <img v-else src="@/assets/img/avatarUrl.png" />
              <div class="evaluate_sec_con">
                <p>
                  <span>{{ item.MemberName }}：</span>{{ item.Comment }}
                </p>
                <div class="evaluate_sec_con_time">
                  <span>{{ item.CreateTime }}</span>
                  <div>
                    <span @click="replayHandle(item)" class="d2-mr-10">
                      <d2-icon class="d2-mr-5" name="commenting-o" />{{item.CommentCount}}</span>

                    <span @click="agreeHandle(item)">
                      <d2-icon class="d2-mr-5" :name="item.AgreeType == 1 ? 'heart' : 'heart-o'" />
                      {{item.AgreeCount}}</span>

                  </div>
                </div>
                <div class="evaluate_replay_box" v-if="item.Children && item.Children.length != 0">
                  <div v-for="(obj, i) in item.Children" :key="i">
                    <img v-if="obj.avatarUrl" :src="$apiUrl + obj.avatarUrl" />
                    <img v-else src="@/assets/img/avatarUrl.png" />
                    <div class="evaluate_sec_con_time">
                      <span>{{ obj.MemberName }}</span>:{{ obj.Comment }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="evaluate_con">
            <el-empty :image-size="100" description="暂无评论"></el-empty>
          </div>
          <!-- 无评论信息不显示 -->
          <template v-if="isWdfbOption"> </template>
          <template v-else>
            <div class="evaluate_Commit">
              <div class="evaluate_Commit_input">
                <el-input :placeholder="
                  !rdComment
                    ? '该用户无法评论'
                    : disComment
                    ? '您已被禁言'
                    : webData.IsCommentAllow == '否'
                    ? '已关闭评论'
                    : '说点什么...（最多200字）'
                " prefix-icon="el-icon-edit" v-model="Comment" maxlength="200" size="mini" class="d2-theme-search1"
                  :disabled="
                  disComment ||
                  webData.IsCommentAllow == '否' ||
                  onlyLook ||
                  !rdComment
                ">
                </el-input>
                <el-button :disabled="
                  disComment ||
                  webData.IsCommentAllow == '否' ||
                  onlyLook ||
                  !rdComment
                " class="d2-ml-5" size="mini" type="primary" icon="el-icon-upload2" circle @click="addComment">
                </el-button>
              </div>
              <span class="evaluate_Commit_Num" @click="agreeHandle('')">
                <d2-icon :name="agreeType == 0 ? 'heart-o' : 'heart'" />
                {{ count }}</span>
            </div>
          </template>
        </el-col>
      </template>

    </el-row>
    <!-- 表单以及流程 -->
    <!-- 未完结 -->
    <el-row class="h100 form_taskbox" v-if="query.type == 'form'">
      <task-common :listDetialData="listDetialData" :name='name' ref="task" />
    </el-row>
    <el-row class="h100" v-if="query.code == 'plat'">
      <div class="box-shadow d2-p-20">
        <div v-html="platCon"></div>
      </div>
      <div class="exchange_box">
        <el-checkbox v-model="radioPrivacy">
          <el-button type="text" class="login-cut-btn" @click="showUserPrivacy">
            <span style="color: #666">已阅读使用须知</span>
          </el-button>
        </el-checkbox>
        <el-link type="primary" @click="changeHandle('我的兑换')">我的兑换</el-link>
      </div>
      <div style="text-align: center;" v-if="this.$store.state.d2admin.userInfo.userinfo.uInfo.RoleName =='正式会员'">
      <el-button type="primary" round size="small" v-if="!showBtn" disabled="false" class="exchange_box_btn" @click="goBfd">请使用移动设备登录商城
      </el-button>
      <!-- <el-button type="primary" round size="small" v-if="showBtn" :disabled="!radioPrivacy" class="exchange_box_btn" @click="gojd">前往京东
      </el-button> -->
      <el-button type="primary" round size="small" v-if="showBtn" :disabled="!radioPrivacy" class="exchange_box_btn" @click="goBfd">前往东福
      </el-button>
      <el-button type="primary" round size="small" v-if="showBtn" :disabled="!radioPrivacy" class="exchange_box_btn" @click="goDyf" >京东健康
      </el-button>
    </div>
    </el-row>
    <div v-if="query.type == 'web'" style="height: 780px">
      <iframe style="width: 100%; height: 100%; border: 0" :src="webUrl" id="iframe"></iframe>
    </div>
    <edit-publish :publish="publish" v-model="editPublishVisible" @submit="getPublishData" />
    <!-- 回复 -->
    <el-dialog :title="'回复:' + replyName" :visible.sync="dialogVisible" width="40%" v-loading="loadsing"
      element-loading-text="提交中...">
      <el-input type="textarea" :rows="4" placeholder="请输入回复内容" v-model="replyText">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="replaySubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 报名活动 -->
    <sign-up :signUpData="signUpData" :HDFL="webData.HDFL" v-model="signUpVisible" @submit="getReloadActivity" />

    <!-- 回复 -->
    <el-dialog title="填写备注" :visible.sync="signUpRemarkVisible" width="40%" v-loading="loadsing"
      element-loading-text="提交中...">
      <el-input type="textarea" :rows="4" placeholder="请输入回复内容" v-model="signUpRemark">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="signUpRemarkVisible = false">取 消</el-button>
        <el-button type="primary" @click="signUpRemarkSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
  import {
    mapState,
    mapActions
  } from "vuex";
  import * as indexService from "@/api/sys/index";
  import form from "@/libs/form";
  import _ from "lodash";
  import dayjs from "dayjs";
  import editPublish from "./editPublish";
  import signUp from "./signUp";
  import richTextData from "@/libs/richTextData";
  import TaskCommon from "./TaskCommon";
  import moment from "moment";
  export default {
    components: {
      editPublish,
      signUp,
      TaskCommon,
    },
    data() {
      return {
        loading: false,
        loadsing: false, //评论加载
        query: {}, //路由
        webData: {}, //数据
        ImgUrlList: [], //图片列表
        Comment: "", //评论内容
        disComment: false, //是否禁言
        permission: false, //是否权限
        likeing: false, //点赞

        rdAgree: true,
        rdComment: true,

        flag: false, //是否黑名单
        agreeType: 0,
        count: 0,
        commentList: [], //评论列表
        // form

        editPublishVisible: false,
        publish: {},
        listDetialData: {},
        name: '',

        // plat
        platCon: "",
        radioPrivacy: false,

        dialogVisible: false,
        replyItem: {},
        replyName: "",
        replyText: "",

        //
        dialogReceiverVisible: false,
        ReceiverList: [],
        //评价框高度
        viewHeight: 0,
        isApply: false,
        isHouBu: false,
        signUpInfo: [],
        HouBuArray: [],
        endApply: false,
        onlyLook: false,

        // 报名活动
        signUpVisible: false,
        signUpData: {},
        groupData: [],

        // 报名活动填写备注
        signUpRemarkVisible: false,
        signUpRemark: '',
        // web
        webUrl: "",
        showBtn:false,
        isDyf_flag:moment(this.$store.state.d2admin.userInfo.userinfo.uInfo.JoinMemberDay)<moment('2025-04-01')
      };
    },
    computed: {
      ...mapState("d2admin/page", ["current"]),
      ...mapState("d2admin/router", ["info"]),
      isWdfbOption() {
        return (
          this.webData &&
          this.info.routeFrom &&
          this.info.routeFrom == "我的发布" &&
          this.info.shortTitle.indexOf("职代会热点") != -1 &&
          this.commentList.length == 0
        );
      },
      unitname() {
        return this.$store.state.d2admin.userInfo.userinfo;
      },
    },
    beforeUpdate() {
      var h =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      document.getElementsByClassName("web_evaluate") &&
        (this.viewHeight = h - 170);
    },
    created() {
      this.query = this.$route.query;
      console.log(this.info, this.query);
      if (this.current) {
        this.set(this.query);
        if (this.query.code == "comment") {
          //评价
          this.getWebView();
        } else if (this.query.code == "activity") {
          //活动
          if (this.query.name) {
            this.GetSignUpInfo();
          }
          this.getWebViewActivity();
        } else if (this.query.code == "plat") {

        } else {
          if (this.query.type == "form") {
            //表单
            this.getFormData();
          } else if (this.query.type == "web") {
            //外部链接
            this.webUrl =
              this.$apiUrl +
              "/ProjectModule/WebPages/RedirectTo.aspx?url=" +
              encodeURIComponent(this.query.id);
          } else if (this.query.type == "richText") {
            //工会信息内部
            this.onlyLook =
              this.query.onlylook || this.info.onlyLook ?
              this.query.onlylook == "false" || this.info.onlyLook == "false" ?
              false :
              true :
              false;
            this.query = {
              code: "comment",
              shortTitle: this.query.title == '提问列表' ? '主席信箱' : this.query.title,
              detailed: false,
              dataId: this.query.dataId,
              fiter: "",
            };
            let querys = {
              ...this.query,
              type: this.query.type,
              onlyLook: this.onlyLook,
            }
            this.set(querys);
            this.getWebView();
          }
        }
      } else {
        if (Object.keys(this.info).length) {
          this.query = this.info;
          if (this.query.code == "comment") {
            this.onlyLook = this.info.onlyLook ? this.info.onlyLook == "false" ?
              false :
              true :
              false;
            this.getWebView();
          } else if (this.query.code == "activity") {
            if (this.query.name) {
              this.GetSignUpInfo();
            }
            this.getWebViewActivity();
          } else if (this.query.code == "plat") {} else {

            this.getFormData();
          }
        } else {
          let tagName = this.current;
          this.close({
            tagName,
            vm: this,
          });
        }
      }
      this.platCon = richTextData.platHtml;
    },
    mounted() {
      // console.log(this.info);
    },
    methods: {
      ...mapActions("d2admin/router", ["set"]),
      ...mapActions("d2admin/page", ["close"]),
      // 活动详情
      getWebViewActivity() {
        this.loading = true;
        let prams = {
          activityId: this.query.dataId,
          limit: 10000,
          orderby: "SortIndex",
          start: 1,
        };
        indexService.GetActivityDetail(prams).then((data) => {
          this.webData = data.data.mainData;
          this.groupData = data.data.groupData;
          this.GetDZCount();
          this.IsInBlackList();
          this.isEndApply();
        });
      },
      getReloadActivity() {
        this.GetSignUpInfo();
        this.getWebViewActivity();
      },
      // 报名活动
      startSignUp() {
        if (
          this.webData.FamilyObject == "on" &&
          this.webData.ActivityParton == "旅游出行" &&
          !this.unitname.uInfo.Job &&
          this.webData.IsRemind &&
          this.webData.IsRemind == "on" &&
          this.signUpInfo.length == 0
        ) {
          this.$alert(this.webData.FamilyReminder, "温馨提示", {
            dangerouslyUseHTMLString: true,
            callback: (action) => {
              if (action == "confirm") {
                this.signUpVisible = true;
                this.signUpData = {
                  ActivityParton: this.webData.ActivityParton,
                  StartTime: this.webData.StartTime,
                  ID: this.webData.ID,
                };
              }
            },
          });
        } else {
          this.signUpVisible = true;
          this.signUpData = {
            ActivityParton: this.webData.ActivityParton,
            StartTime: this.webData.StartTime,
            ID: this.webData.ID,
          };
        }
      },
      // 填写备注
      addRemarkHandle() {
        let parmas = {
          activityId: this.webData.ID,
        };
        indexService.GetSignUpRemark(parmas).then((res) => {
          this.signUpRemarkVisible = true;
          this.signUpRemark = res.data
        });
      },
      signUpRemarkSubmit() {
        if (!this.signUpRemark) {
          this.$message.error('请输入备注！')
          return;
        }
        let parmas = {
          activityId: this.webData.ID,
          remark: this.signUpRemark,
        };
        indexService.SetSignUpRemark(parmas).then((res) => {
          this.signUpRemarkVisible = false;
          this.$message.success('保存成功！')
        });
      },
      signUpSubmit() {
        this.signUpVisible = false;
      },
      // 我要报名
      enrollHandle() {
        if (
          this.groupData[0] &&
          this.groupData[0].detailTable &&
          this.groupData[0].detailTable[0]
        ) {
          let dataCode = [`${this.groupData[0].detailTable[0].DataCode}|1`];
          let parmas = {
            dataCode: dataCode,
          };
          indexService.GetSubstituteCount(parmas).then((res) => {
            var {
              data
            } = res;
            if (data.allCount == 0) {
              this.$confirm("是否确认参加此次活动?", "提醒", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success",
                })
                .then(() => {
                  ok();
                })
                .catch(() => {});
            } else {
              var {
                list
              } = data;
              var str = "";
              for (var j = 0; j < list.length; j++) {
                if (list[j].count != 0) {
                  str += `目前${
                  list[j].name
                }存在候补人数<span style="color: #65BDFE">${
                  list[j].count - 1 < 0 ? 0 : list[j].count - 1
                }</span><br>`;
                }
              }
              str += `是否确认加入候补队列？`;
              this.$confirm(str, "提醒", {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success",
                })
                .then(() => {
                  ok(true);
                })
                .catch(() => {});
            }
          });
          var ok = (houbu) => {
            let parmas = {
              dataCode: this.groupData[0].detailTable[0].DataCode,
              activityId: this.webData.ID,
              name: this.webData.ActivityName,
            };
            indexService.SignUpDetail(parmas).then((data) => {
              this.$alert(
                `你已经成功${houbu ? "候补" : "报名"}了${
                this.webData.ActivityName
              }`,
                `${houbu ? "候补" : "报名"}成功`, {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.GetSignUpInfo();
                    this.getWebViewActivity();
                  },
                }
              );
            });
          };
        } else {
          this.$message.error("报名配置错误");
        }
      },
      //取消报名
      quitApply() {
        this.$confirm("是否确认不参加此次活动？", "提醒", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success",
          })
          .then(() => {
            let parmas = {
              activityId: this.webData.ID,
            };
            indexService.CancelSignUp(parmas).then((data) => {
              this.$message.success("取消报名成功");
              this.GetSignUpInfo();
              this.getWebViewActivity();
            });
          })
          .catch(() => {});
      },
      editeErollHandle() {},
      isEndApply() {
        var {
          SignUpStartTime,
          SignUpEndTime,
          ActivityParton
        } = this.webData;
        var now = dayjs();
        SignUpEndTime = dayjs(SignUpEndTime).add(1, "seconds");
        console.log(SignUpEndTime)
        // 在开始时间之前，为报名未开始
        if (dayjs().isBefore(dayjs(SignUpStartTime))) {
          if (this.isApply) {
            this.$message.warning("非报名时间段");
          } else {
            this.$message.warning("未到报名开始时间");
          }
          this.endApply = true;
          return false;
        }

        // 在结束时间之后，为报名结束
        if (dayjs().isAfter(dayjs(SignUpEndTime))) {
          if (this.isApply) {
            if (ActivityParton == "社区分享") {
              this.$message.warning("不在活动时间，无法发布分享");
            } else {
              this.$message.warning("非报名时间段");
            }
          } else if (ActivityParton != "其他" && ActivityParton != "专项礼品") {
            if (ActivityParton == "社区分享") {
              this.$message.warning("不在活动时间，无法发布分享");
            } else {
              this.$message.warning("报名已截止");
            }
          }
          this.endApply = true;
          return false;
        }
        console.log(this.endApply)
        this.endApply = false;
        return true;
      },
      GetSignUpInfo() {
        this.loading = true;
        let prams = {
          activityId: this.query.dataId,
          limit: 10000,
          orderby: "SortIndex",
          start: 1,
        };
        indexService.GetSignUpInfo(prams).then((data) => {
          if (data.data.length == 0) {
            this.isApply = false;
          } else {
            this.isApply = true;
            this.signUpInfo = data.data;
            var flag = true;
            for (var v of this.signUpInfo) {
              if (v.SignStatus == 1) {
                flag = false;
              }
            }
            this.isHouBu = flag;
          }

          // getData();

          // 检查排名
          var array = [];
          for (var i = 0; i < data.data.length; i++) {
            if (!data.data[i].Position) {
              continue;
            } else {
              array.push({
                Position: data.data[i].Position,
                LineName: data.data[i].LineName ? data.data[i].LineName : null,
              });
            }
          }
          this.HouBuArray = array;
        });
      },
      // 详情
      getWebView() {
        this.loading = true;
        indexService.getWebView(this.query).then((data) => {
          this.webData = data.data.mainData;
          if (this.webData.ImgUrl) {
            let imgurl = this.webData.ImgUrl.split(",");
            this.ImgUrlList = imgurl;
          } else if (this.webData.Materials) {
            let imgurl = this.webData.Materials.split(",");
            this.ImgUrlList = imgurl.map((v) => {
              return v.indexOf("http") == -1 ? this.$apiUrl + v : v;
            });
          }
          this.commentCheck();
          this.GetDZCount();
          this.GetCommentList();
          this.getReplyPermission();
        });
      },

      // 获取表单信息
      getFormData() {
        this.listDetialData = {
          ID: this.info.dataId,
          Type: this.info.title,
          Title: this.info.title,
          _TEMPLATE_ID: ''
        }
        this.name = this.info.formType;
        this.$nextTick(() => {
          console.log(this.$refs.task)
          this.$refs.task.GetRootConfigValue(this.info.title);
        })
        this.$forceUpdate();

      },
      // 流程
      GetWorkflowRecord(TEMPLATE_ID) {
        let parmas = {
          dataId: this.query.dataId,
          templateId: TEMPLATE_ID,
        };
        indexService.GetWorkflowRecord(parmas).then((data) => {
          this.flowRecord = data.data;
          this.active = data.data.length;
          this.loading = false;
        });
      },
      ifCheck(col) {
        var _this = this;
        if (col.if) {
          var a = eval(col.if);
          if (!a) {}
          return a;
        }
        return true;
      },
      // 是否评论
      // getUserCanSpeak() {
      //   indexService.getUserCanSpeak().then((data) => {
      //     this.disComment = data.data;
      //     this.loading = false;
      //   });
      // },
      // 评价量
      GetDZCount() {
        let prams = {
          DataId: this.webData.ID,
          TemplateId: this.webData._TEMPLATE_ID,
        };
        indexService.GetDZCount(prams).then((data) => {
          this.agreeType = data.agreeType;
          this.count = data.count;
          this.$forceUpdate();
          this.loading = false;
        });
      },
      // 评价列表
      GetCommentList() {
        let prams = {
          DataId: this.webData.ID,
          TemplateId: this.webData._TEMPLATE_ID,
          limit: 1000,
          start: 1,
        };
        indexService.GetCommentList(prams).then((data) => {
          this.commentList = data.data;
          this.loading = false;
        });
      },
      // 权限
      getReplyPermission() {
        let query = {
          dataId: this.webData.ID,
          templateId: this.webData._TEMPLATE_ID,
        };
        indexService.getReplyPermission(query).then((data) => {
          this.permission = data.data.permission;
          this.loading = false;
        });
      },
      // 是否黑名单
      IsInBlackList() {
        let query = {
          activityId: this.webData.ID,
        };
        indexService.IsInBlackList(query).then((data) => {
          this.flag = data.data.flag;
          if (data.data.flag == true) {
            this.$alert(
              `因为您在活动黑名单中，${data.data.tip ? data.data.tip : ""}${
              data.data.tip ? "，" : ""
            }若有疑问请联系管理员`,
              "提醒", {
                confirmButtonText: "确定",
                callback: (action) => {},
              }
            );
          }
          this.loading = false;
        });
      },
      // 职代会热点    职代会代表专线
      commentCheck() {
        if (
          this.info.shortTitle &&
          (this.info.shortTitle == "职代会热点" ||
            this.info.shortTitle == "工会职代会热点")
        ) {
          indexService
            .GetUnionHotConfig()
            .then((data) => {
              var {
                agree,
                comment
              } = res.data;
              this.rdAgree = agree;
              this.rdComment = comment;
            })
            .catch((err) => {});
        } else {
          indexService.getUserCanSpeak().then((data) => {
            this.disComment = !data.data;
          });
        }
      },
      // 点赞
      agreeHandle(item) {
        if (
          this.info.shortTitle &&
          (this.info.shortTitle == "职代会热点" ||
            this.info.shortTitle == "工会职代会热点") &&
          !this.rdAgree
        ) {
          this.$message.error("该用户禁止点赞");
          return;
        }
        if (this.webData.IsDianZanAllow == "否" || this.onlyLook) {
          this.$message.error("点赞已关闭");
          return;
        }
        if (this.likeing) {
          return;
        }
        let query = {};
        if (item) {
          //单个点赞
          query = {
            DataId: item.ID,
            TemplateId: item._TEMPLATE_ID,
          };
        } else {
          //整个点赞
          query = {
            DataId: this.webData.ID,
            TemplateId: this.webData._TEMPLATE_ID,
          };
        }
        this.likeing = true;
        indexService
          .getAgreeData(query)
          .then((data) => {
            this.likeing = false;
            if (item) {
              if (data.success && item.AgreeType != 1) {
                this.$message.success("点赞成功！");
              } else {
                this.$message.warning("取消点赞！");
              }
              this.GetCommentList();
            } else {
              if (data.success && this.agreeType == 0) {
                this.$message.success("点赞成功！");
              } else {
                this.$message.warning("取消点赞！");
              }
              this.GetDZCount();
            }
          })
          .catch((err) => {
            this.$message.error(err.message);
            this.likeing = false;
          });
      },
      // 添加评论
      addComment() {
        if (!this.Comment) {
          this.$message.error('请输入评论内容！');
          return;
        }
        let query = {
          Comment: this.Comment,
          DataId: this.webData.ID,
          TemplateId: this.webData._TEMPLATE_ID,
        };
        if (
          this.info.shortTitle == "职代会热点" ||
          this.info.shortTitle == "工会职代会热点"
        ) {
          query = {
            ...query,
            from: this.info.shortTitle,
            title: this.webData.Subject,
          };
          if(this.info.shortTitle == "工会职代会热点"){
            query.title=this.webData.Title;
          }
        } else {
          query = {
            ...query,
            from: this.webData.Type,
            title: this.webData.Title,
          };
        }
        this.loadsing = true;
        indexService
          .AddCommentData(query)
          .then((data) => {
            if (data.success) {
              this.$message.success(data.message);
              this.Comment = "";
            } else {
              this.$message.error("评论失败！");
            }
            this.loadsing = false;
            this.GetCommentList();
          })
          .catch((e) => {
            this.loadsing = false;
            this.$message.error(e);
          });
      },
      // 回复评论
      replayHandle(item) {
        console.log(item);
        this.replyName = item.MemberName;
        this.replyItem = {
          DataId: item.ID,
          TemplateId: item._TEMPLATE_ID,
        };
        this.dialogVisible = true;
      },
      replaySubmit() {
        if (!this.replyText) {
          this.$message.error('请输入回复内容！');
          return;
        }
        let query = {
          Comment: this.replyText,
          DataId: this.replyItem.DataId,
          TemplateId: this.replyItem.TemplateId,
          from: this.info.shortTitle,
          title: this.webData.Subject,
          toName: this.replyName,
        };
        this.loadsing = true;
        indexService
          .AddCommentData(query)
          .then((data) => {
            if (data.success) {
              this.$message.success(data.message);
              this.Comment = "";
            } else {
              this.$message.error("评论失败！");
            }
            this.loadsing = false;
            this.dialogVisible = false;
            this.GetCommentList();
          })
          .catch((e) => {
            this.loadsing = false;
            this.$message.error(e);
          });
      },

      getPublishData() {
        this.getWebView();
      },
      // 编辑
      editHandle(item) {
        this.editPublishVisible = true;
        this.publish = item;
      },
      // 删除
      deleteHandle(ID) {
        this.$confirm("是否删除此条发布信息?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            this.loadings = true;
            var param = {
              id: ID,
            };
            indexService
              .DeleteUnionHot(param)
              .then(() => {
                this.$message.success("删除成功！");
                this.loadings = false;
                this.$router.go(-1);
              })
              .catch((e) => {
                this.$message.error(e.message);
                this.loadings = false;
              });
          })
          .catch(() => {});
      },
      showUserPrivacy() {
        this.PrivacyShow = true;
      },
      // 跳转至我的兑换
      changeHandle(val) {
        this.$router.push({
          name: `myunion`,
          params: {
            val: val,
          },
        });
      },
      // 跳转京东
      gojd() {
        indexService
          .JumpJD(this.unitname.uInfo.AdAccount)
          .then((data) => {
            window.open(data.data.url, "_blank");
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      },
      goBfd() {
        indexService
          .JumpBfd(this.unitname.uInfo.AdAccount)
          .then((data) => {
            var url ="https://open-dbenefit.dongfangfuli.com/openApi/auth/redirect/standard?"+data.data.param;
            window.open(url, "_blank");
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      },
      goDyf() {
        indexService
          .JumpDyf()
          .then((data) => {
            var url = data.url;
            window.open(url, "_blank");
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/public.scss";
  @import "~@/assets/style/style.css";

  /deep/ .el-carousel__button {
    width: 10px;
  }

  .formbirth {
    background: #fff;
    padding: 20px 30px 20px 0;
    border-radius: 10px;
    box-shadow: 0px 0px 15px #bfd3e8;
  }

  .form_taskbox {
    background: #fff;
    padding: 20px 0 0 0;
    border-radius: 10px;
    box-shadow: 0px 0px 15px #bfd3e8;
  }

  .flow_Record {
    padding: 20px;
    margin: 0 20px;
    box-shadow: 0px 0px 15px #bfd3e8;
    border-radius: 10px;
    background: #fff;
  }

  /deep/ .el-step__description {
    padding-right: 0;
  }

  .step-box {
    display: flex;

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 4px;
    }
  }

  .step-infobox {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    align-items: baseline;
    background: #f7faff;
    padding: 8px;
    border-radius: 5px;

    div {
      width: 50%;
      margin-top: 6px;
    }

    .user {
      font-size: 14px;
      color: #000;
    }

    .action {
      color: #999;
      font-size: 14px;
    }

    .time {
      color: #999;
      text-align: right;
      font-size: 12px;
    }
  }

  .question_panel {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-bottom: 15px;
    border-top: 0;

    .question_panel_body {
      padding-top: 0;
    }
  }

  .card_question_bottom {
    margin-top: 13px;
    line-height: 12px;

    .time {
      font-size: 13px;
      color: #999;
    }

    .button {
      padding: 0;
      float: right;
      color: #999;
    }
  }

  .card_question_info {
    font-size: 12px;
    color: #666;
    line-height: 26px;
  }

  .mt-20 {
    margin-top: 20px;
  }
</style>